export class RepositoryBase {
  saveEvent() {}

  getEvents() {}

  removeEvents() {}
}